import { useStoreon } from 'storeon/react';
import { EKeycardType, LoyaltyRegistrationModalStore } from 'reducers';
import { useEffect } from 'react';
import { CHECK_PHONE_VERIFY_REQUEST, REGISTRATION_MODAL } from 'actions';

export const usePreselectLoyaltyCard = () => {
  const { dispatch, loyaltyRegistrationModal } =
    useStoreon<LoyaltyRegistrationModalStore>('loyaltyRegistrationModal');

  useEffect(() => {
    if (loyaltyRegistrationModal.show && loyaltyRegistrationModal.preselectCard) {
      if ([EKeycardType.HOME, EKeycardType.PRO].includes(loyaltyRegistrationModal.preselectCard)) {
        dispatch(REGISTRATION_MODAL.setChooseKeycardData, {
          keycardType: loyaltyRegistrationModal.preselectCard,
          marketingConsent: true,
        });

        dispatch(CHECK_PHONE_VERIFY_REQUEST.request, {
          keycardType: loyaltyRegistrationModal.preselectCard,
          marketingConsent: true,
        });
      }
    }
  }, [loyaltyRegistrationModal.preselectCard, dispatch, loyaltyRegistrationModal.show]);
};
